import type { EditorialContent } from '@shared-types/editorial.types';

export const isDescriptionLink = (teaser: EditorialContent) => {
  if (typeof teaser?.description !== 'string') return false;

  const urlPattern = /^(https?:\/\/[^\s/$.?#].[^\s]*)|(^\/(?!\/)|^\.\.?(\/|$))/i;
  return urlPattern.test(teaser?.description);
};

export const disableLink = (teaser: EditorialContent) => !isDescriptionLink(teaser) && !teaser.ctaLabel;

export const bolderIsNumber = (teaser: EditorialContent) => {
  const bTagText = getBTagText(teaser.headline);

  const isFirstBTagCharNumber = bTagText.length > 0 && /^\d/.test(bTagText[0]);
  return isFirstBTagCharNumber;
};

export const getBTagText = (html: string) => {
  const bTagRegex = /<b>(.*?)<\/b>/g;
  const matches = [];
  let match;
  while ((match = bTagRegex.exec(html)) !== null) {
    matches.push(match[1]);
  }
  return matches;
};
